<template>
  <div class="content-body" style="padding-top: 6rem">
    <div class="container-fluid">
      <div class="page-titles">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">Slider</a>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'Slider Product Home' }"
              >Data Slider Product Home</router-link
            >
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">{{ currentRouteName }}</a>
          </li>
        </ol>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Form {{ currentRouteName }}</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <div class="form-group">
                  <label class="col-sm-3 col-form-label">Title Slide</label>
                  <input
                    v-model="editForm.title"
                    @input="generateSlug"
                    type="text"
                    class="form-control"
                    placeholder="Title Slide"
                  />
                </div>
                <div class="form-group">
                  <label class="col-sm-3 col-form-label">Slug URL</label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.slug"
                      type="text"
                      class="form-control"
                      placeholder="Slug URL"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 col-form-label">Deskripsi Slide</label>
                  <textarea
                    ref="summernote"
                    class="form-control summernote"
                    id="deskripsi"
                    v-model="editForm.deskripsi"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label for="image_desktop">Desktop Image</label>
                  <input
                    type="file"
                    id="image_desktop"
                    @change="handleFileUpload($event, 'desktop')"
                    class="form-control-file"
                    accept="image/*"
                  />
                  <img
                    v-if="imagePreviewDesktop"
                    :src="imagePreviewDesktop"
                    alt="Desktop Preview"
                    class="img-thumbnail mt-3"
                    style="max-width: 300px"
                  />
                </div>
                <div class="form-group">
                  <label for="image_mobile">Mobile Image</label>
                  <input
                    type="file"
                    id="image_mobile"
                    @change="handleFileUpload($event, 'mobile')"
                    class="form-control-file"
                    accept="image/*"
                  />
                  <img
                    v-if="imagePreviewMobile"
                    :src="imagePreviewMobile"
                    alt="Mobile Preview"
                    class="img-thumbnail mt-3"
                    style="max-width: 300px"
                  />
                </div>
                <div class="form-group">
                  <label for="alt">Alt Text</label>
                  <input
                    type="text"
                    id="alt"
                    v-model="editForm.alt"
                    class="form-control"
                    placeholder="Enter alt text"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="url">URL</label>
                  <input
                    type="text"
                    id="url"
                    v-model="editForm.url"
                    class="form-control"
                    placeholder="Enter URL"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="is_publish">Publish Status</label>
                  <select
                    id="is_publish"
                    v-model="editForm.is_publish"
                    class="form-control"
                    required
                  >
                    <option value="">Select Status</option>
                    <option value="true">Publish</option>
                    <option value="false">Unpublish</option>
                  </select>
                </div>
                <button class="btn btn-warning btn-sm mr-1" @click="goBack">
                  <i class="fa fa-arrow-left"></i> Kembali
                </button>
                <button
                  type="submit"
                  @click="updateSlider"
                  class="btn btn-primary btn-sm mr-1"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";
import defaultURL from "@/config";

export default {
  name: "Edit Slider Product Home",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const summernote = ref(null);
    const editForm = ref({
      title: "",
      slug: "",
      deskripsi: "",
      image_desktop: null,
      image_mobile: null,
      alt: "",
      url: "",
      is_publish: "",
      user: null,
      id_kategori: 8,
    });

    const imagePreviewDesktop = ref(null);
    const imagePreviewMobile = ref(null);
    const currentRouteName = computed(() => route.name);
    const token = computed(() => store.getters.token);

    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get("/user", {
          headers: {
            Authorization: `Bearer ${token.value}`,
          },
        });

        if (response.status === 200) {
          editForm.value.user = response.data.id;
        } else {
          handleAuthError(new Error("Failed to fetch user data"));
        }
      } catch (error) {
        handleAuthError(error);
      }
    };

    const fetchSliderData = async () => {
      const id = route.params.id;
      try {
        const response = await axiosInstance.get(`/slider/${id}`, {
          headers: {
            Authorization: `Bearer ${token.value}`,
          },
        });
        if (response.status === 200) {
          const data = response.data.data;
          imagePreviewDesktop.value = `${defaultURL}/images/slider/desktop/${data.image_desktop}`;
          imagePreviewMobile.value = `${defaultURL}/images/slider/mobile/${data.image_mobile}`;

          editForm.value = {
            ...editForm.value,
            title: data.title || "",
            slug: data.slug || generateSlugFromTitle(data.title),
            deskripsi: data.deskripsi || "",
            image_desktop: data.image_desktop,
            image_mobile: data.image_mobile,
            alt: data.alt,
            url: data.url,
            is_publish: data.is_publish,
            user: editForm.value.user,
            id_kategori: data.id_kategori || 8,
          };
          // Tunggu sampai DOM diupdate
          await nextTick();
          // Initialize Summernote dengan nilai awal
          initializeSummernote();
          // $(summernote.value).summernote("code", editForm.value.deskripsi);
        } else {
          Swal.fire("Error", "Failed to fetch slider data.", "error");
        }
      } catch (error) {
        Swal.fire("Error", `Error fetching data: ${error.message}`, "error");
      }
    };

    const initializeSummernote = () => {
      if (summernote.value) {
        $(summernote.value).summernote({
          height: 200,
          callbacks: {
            onChange: function (contents) {
              editForm.value.deskripsi = contents;
            },
            onInit: function () {
              // Set initial content
              $(summernote.value).summernote("code", editForm.value.deskripsi);
            },
          },
        });
      }
    };

    const updateSlider = async () => {
      const formData = new FormData();
      // console.log("Isi editForm sebelum dikirim:", editForm.value);
      const currentContent = $(summernote.value).summernote("code");
      editForm.value.deskripsi = currentContent;

      for (const key in editForm.value) {
        if (
          editForm.value[key] &&
          key !== "image_desktop" &&
          key !== "image_mobile"
        ) {
          formData.append(key, editForm.value[key]);
        }
      }

      if (editForm.value.image_desktop instanceof File) {
        formData.append("image_desktop", editForm.value.image_desktop);
      } else if (typeof editForm.value.image_desktop === "string") {
        formData.append("image_desktop", editForm.value.image_desktop);
      }

      if (editForm.value.image_mobile instanceof File) {
        formData.append("image_mobile", editForm.value.image_mobile);
      } else if (typeof editForm.value.image_mobile === "string") {
        formData.append("image_mobile", editForm.value.image_mobile);
      }

      // Debugging: Log semua data yang akan dikirim
      // console.log("Data yang akan dikirim:");
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}: ${pair[1]}`);
      }

      try {
        const response = await axiosInstance.post(
          `/slider-update/${route.params.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token.value}`,
            },
          }
        );

        if (response.status === 200) {
          Swal.fire("Success", "Slider updated successfully!", "success").then(
            () => {
              router.push({ name: "Slider Product Home" });
            }
          );
        } else {
          Swal.fire("Error", "Failed to update slider.", "error").then(() => {
            window.location.reload();
          });
        }
      } catch (error) {
        Swal.fire(
          "Error",
          `Error updating slider: ${error.message}`,
          "error"
        ).then(() => {
          window.location.reload();
        });
      }
    };

    const handleFileUpload = (event, type) => {
      const file = event.target.files[0];
      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      // Validate file type
      if (!validTypes.includes(file.type)) {
        Swal.fire({
          title: "Invalid File Type",
          text: "Please select an image with format jpeg, jpg, png, or svg.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        Swal.fire({
          title: "File Too Large",
          text: "Please select an image smaller than 2MB.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      if (type === "desktop") {
        editForm.value.image_desktop = file;
        imagePreviewDesktop.value = URL.createObjectURL(file);
      } else if (type === "mobile") {
        editForm.value.image_mobile = file;
        imagePreviewMobile.value = URL.createObjectURL(file);
      }
    };

    const handleAuthError = (error) => {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        store.dispatch("setAuth", false);
        store.dispatch("setToken", { token: null, expiry: null });
        localStorage.clear();
        router.push({ name: "Login" });
      });
    };

    const checkTitleExistence = async () => {
      try {
        const response = await axiosInstance.get(
          `/blog-slug/${editForm.value.slug}`,
          {
            headers: {
              Authorization: `Bearer ${token.value}`,
            },
          }
        );

        console.log("Response data:", response.data);

        // Check if the response indicates the title already exists
        if (
          response.data.success &&
          response.data.message === "Title Sudah Digunakan"
        ) {
          Swal.fire({
            title: "Warning",
            text: "The slug already exists, please choose another title.",
            icon: "warning",
            confirmButtonText: "OK",
          });
          editForm.value.slug = ""; // Clear the slug if it exists
        }
      } catch (error) {
        console.error("Error checking slug existence", error);
      }
    };

    const generateSlug = async () => {
      editForm.value.slug = editForm.value.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      await checkTitleExistence();
    };

    const generateSlugFromTitle = (title) => {
      return title
        ? title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "")
        : "";
    };

    const goBack = () => {
      router.push({ name: "Slider Product Home" });
    };

    onMounted(async () => {
      await fetchUser();
      await fetchSliderData();
      await nextTick();
      $(summernote.value).summernote({
        height: 200,
        callbacks: {
          onChange: (contents) => {
            console.log("Deskripsi baru:", contents);
            editForm.value.deskripsi = contents;
          },
        },
      });
      // Pastikan deskripsi tersinkron setelah data di-fetch
      $(summernote.value).summernote("code", editForm.value.deskripsi);
    });

    watch(
      editForm,
      (newValue) => {
        nextTick(() => {});
      },
      { deep: true }
    );

    return {
      currentRouteName,
      editForm,
      imagePreviewDesktop,
      imagePreviewMobile,
      handleFileUpload,
      updateSlider,
      goBack,
      summernote,
      generateSlug,
      generateSlugFromTitle,
    };
  },
};
</script>
